export function getPrePackAvailability(prePack) {
    if (prePack.isLocked) {
        return "locked";
    }
    if (prePack.isSuspended) {
        return "suspended";
    }
    return;
}
//# sourceMappingURL=getPrePackAvailability.js.map